/* NTRL1 · PDP — comportamiento e interacciones de las secciones ntrl-* (sin dependencias) */
(function () {
  if (window.__ntrlPdp) return;
  window.__ntrlPdp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  function once(el, key) { if (el['__ntrl' + key]) return false; el['__ntrl' + key] = true; return true; }

  /* ---------- Cuenta atrás ---------- */
  function initTimer(el) {
    if (!once(el, 't')) return;
    var mode = el.dataset.mode || 'midnight';
    var minutes = parseInt(el.dataset.minutes || '120', 10);
    var key = 'ntrl-timer-' + (el.dataset.key || 'default');
    function nextEnd() {
      if (mode === 'evergreen') {
        var stored = null;
        try { stored = parseInt(localStorage.getItem(key), 10); } catch (e) {}
        if (!stored || stored < Date.now()) {
          stored = Date.now() + minutes * 60000;
          try { localStorage.setItem(key, String(stored)); } catch (e) {}
        }
        return stored;
      }
      var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();
    }
    var end = nextEnd();
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function set(node, v) { if (node && node.textContent !== v) { node.textContent = v; if (!reduce) { node.classList.remove('is-tick'); void node.offsetWidth; node.classList.add('is-tick'); } } }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { end = nextEnd(); left = Math.max(0, end - Date.now()); }
      var t = Math.floor(left / 1000);
      set(h, pad(Math.floor(t / 3600))); set(m, pad(Math.floor((t % 3600) / 60))); set(s, pad(t % 60));
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Fecha de entrega ---------- */
  function initDelivery(el) {
    if (!once(el, 'd')) return;
    var days = parseInt(el.dataset.days || '3', 10);
    var skip = el.dataset.skipWeekend === 'true';
    var d = new Date(), added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) added++; }
    var wd = ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'];
    var mo = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sept.', 'oct.', 'nov.', 'dic.'];
    el.textContent = wd[d.getDay()] + ', ' + d.getDate() + ' de ' + mo[d.getMonth()];
  }

  /* ---------- Galería (miniaturas + deslizar en móvil) ---------- */
  /* Galería: puntos tipo carrusel (‹ • • ● • • ›, máx. 5 visibles) + portada por pack.
     Las fotos marcadas con data-cover="<variante>" son portadas de un pack: solo se ve la del pack elegido
     (como primera imagen) y después las imágenes generales del producto. */
  function initGallery(root) {
    if (!once(root, 'g')) return;
    var main = root.querySelector('.ntrl-gallery__main');
    var all = [].slice.call(root.querySelectorAll('.ntrl-gallery__slide'));
    var thumbs = [].slice.call(root.querySelectorAll('.ntrl-gallery__thumb'));
    var nav = root.querySelector('[data-ntrl-gnav]');
    var track = nav && nav.querySelector('[data-ntrl-gdots]');
    var MAXD = 5, STEP = 16;
    var vis = [], cur = 0;
    var covers = all.filter(function (s) { return s.hasAttribute('data-cover'); });
    var cover = (main && main.getAttribute('data-cover-active')) || '';
    function isCoverOf(s, v) { return (' ' + s.getAttribute('data-cover') + ' ').indexOf(' ' + v + ' ') > -1; }
    function build() {
      if (covers.length && !covers.some(function (s) { return isCoverOf(s, cover); })) cover = covers[0].getAttribute('data-cover').split(' ')[0];
      vis = all.filter(function (s) { return !s.hasAttribute('data-cover') || isCoverOf(s, cover); });
      // portada del pack siempre la primera
      vis.sort(function (a, b) { return (b.hasAttribute('data-cover') ? 1 : 0) - (a.hasAttribute('data-cover') ? 1 : 0); });
      all.forEach(function (s) { s.classList.toggle('is-out', vis.indexOf(s) < 0); });
      if (track) {
        track.innerHTML = vis.map(function () { return '<span class="ntrl-gnav__dot"></span>'; }).join('');
        var w = Math.min(vis.length, MAXD) * STEP;
        track.parentNode.style.width = w + 'px';
      }
      if (nav) nav.hidden = vis.length < 2;
    }
    function paint() {
      var n = vis.length;
      all.forEach(function (s) { var on = s === vis[cur]; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
      thumbs.forEach(function (x, j) { var on = all[j] === vis[cur]; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (!track) return;
      var start = Math.max(0, Math.min(cur - Math.floor(MAXD / 2), n - MAXD));
      track.style.transform = 'translateX(' + (-start * STEP) + 'px)';
      [].forEach.call(track.children, function (d, j) {
        d.className = 'ntrl-gnav__dot' + (j === cur ? ' is-active' : '') +
          ((j === start && start > 0) || (j === start + MAXD - 1 && start + MAXD < n) ? ' is-edge' : '') +
          ((j < start || j >= start + MAXD) ? ' is-far' : '');
      });
      if (nav) nav.setAttribute('aria-label', 'Imagen ' + (cur + 1) + ' de ' + n);
    }
    function go(i) { if (!vis.length) return; cur = (i + vis.length) % vis.length; paint(); }
    function setCover(v) { v = String(v || ''); if (!covers.length || !covers.some(function (s) { return isCoverOf(s, v); })) return; cover = v; build(); go(0); }
    build(); go(0);
    root.__ntrlGallery = { setCover: setCover, go: function (i) { go(i); } };
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { var k = vis.indexOf(all[j]); if (k > -1) go(k); }); });
    if (nav) {
      var pv = nav.querySelector('[data-ntrl-gprev]'), nx = nav.querySelector('[data-ntrl-gnext]');
      if (pv) pv.addEventListener('click', function () { go(cur - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    }
    if (main) {
      var x0 = null, y0 = 0;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null || vis.length < 2) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
      main.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
    }
  }

  /* ---------- Carruseles ---------- */
  function initScroller(root) {
    if (!once(root, 's')) return;
    var track = root.querySelector('[data-ntrl-track]');
    if (!track) return;
    var prev = root.querySelectorAll('[data-ntrl-prev]'), next = root.querySelectorAll('[data-ntrl-next]');
    var dots = root.querySelectorAll('[data-ntrl-dots] span');
    function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 16) : track.clientWidth; }
    prev.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      next.forEach(function (b) { b.disabled = track.scrollLeft >= max; });
      if (dots.length) { var idx = Math.round(track.scrollLeft / step()); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === Math.min(idx, dots.length - 1)); }); }
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Vídeos UGC ---------- */
  function initVideoCard(card) {
    if (!once(card, 'v')) return;
    var v = card.querySelector('video'), btn = card.querySelector('.ntrl-ugc-card__play');
    if (!v || !btn || btn.tagName !== 'BUTTON') return;
    btn.addEventListener('click', function () {
      if (v.paused) {
        document.querySelectorAll('.ntrl-ugc-card video').forEach(function (o) { if (o !== v) o.pause(); });
        v.muted = false; v.controls = true; v.play(); card.classList.add('is-playing');
      } else { v.pause(); }
    });
    v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
  }

  /* ---------- Desplegables con animación ---------- */
  function initDetails(d) {
    if (!once(d, 'a') || reduce) return;
    var summary = d.querySelector('summary');
    var body = summary && summary.nextElementSibling;
    if (!body) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.__anim) return;
      if (d.open) {
        body.style.height = body.scrollHeight + 'px'; body.style.overflow = 'hidden';
        requestAnimationFrame(function () { body.style.transition = 'height .28s ease, opacity .28s ease'; body.style.height = '0px'; body.style.opacity = '0'; });
        d.__anim = true;
        setTimeout(function () { d.open = false; body.removeAttribute('style'); d.__anim = false; }, 290);
      } else {
        d.open = true;
        var hgt = body.scrollHeight;
        body.style.height = '0px'; body.style.opacity = '0'; body.style.overflow = 'hidden';
        requestAnimationFrame(function () { body.style.transition = 'height .32s ease, opacity .32s ease'; body.style.height = hgt + 'px'; body.style.opacity = '1'; });
        d.__anim = true;
        setTimeout(function () { body.removeAttribute('style'); d.__anim = false; }, 340);
      }
    });
  }

  /* ---------- NTRL CART · carrito lateral propio ----------
     Cada modo (suscripción / compra única) es UN bundle de N bolsas:
       N ≤ 3 → pack N  ·  N > 3 → pack 3 + (N-3) × pack 1   (máx. 99)
     Así los precios siempre cuadran y los regalos nunca pasan de los del pack 3.
     Los regalos se calculan aquí y van en la misma petición (mínimas llamadas). */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var Cart = (function () {
    var el = null, cfg = null, body = null, last = null, busy = false;
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function money(cents, short) {
      var f = (cfg && cfg.moneyFormat) || '${{amount}}';
      var n = (cents || 0) / 100;
      if (short && Math.abs(n - Math.round(n)) < 0.005) f = f.replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}').replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}');
      function fix(v, d, ts, ds) { var p = v.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return fix(n, 0, ',', '.');
        if (k === 'amount_with_comma_separator') return fix(n, 2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return fix(n, 0, '.', ',');
        return fix(n, 2, ',', '.');
      });
    }
    function ico(name, s) {
      var P = {
        minus: '<path d="M5 12h14"/>', plus: '<path d="M12 5v14M5 12h14"/>',
        trash: '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/>',
        repeat: '<path d="M17 2l4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/>',
        tag: '<path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
        gift: '<path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/>',
        up: '<path d="M12 19V5M5 12l7-7 7 7"/>', sub: '<path d="M6 3v10a4 4 0 0 0 4 4h10"/><path d="M16 13l4 4-4 4"/>'
      };
      s = s || 18;
      return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (P[name] || '') + '</svg>';
    }
    function isGift(i) { return !!cfg && (i.variant_id === cfg.gift || (!!cfg.gift2 && i.variant_id === cfg.gift2)); }
    // regalos: [variante, reglas por variante del pack]. El 2.º regalo (p. ej. Vitamina D3 K2) es opcional
    function giftDefs() { return [[cfg.gift, cfg.giftRules || {}], [cfg.gift2, cfg.gift2Rules || {}]].filter(function (g) { return !!g[0]; }); }
    function planOf(i) { return i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null; }
    function packOf(i) { return cfg && cfg.packs[String(i.variant_id)]; }
    function modeOf(i) { return planOf(i) ? 'sub' : 'once'; }
    function setup() {
      if (el) return true;
      el = document.querySelector('[data-ntrl-cart]');
      if (!el) return false;
      if (el.parentElement !== document.body) document.body.appendChild(el);
      try { cfg = JSON.parse(el.querySelector('[data-ntrl-cart-config]').textContent); } catch (e) { cfg = { packs: {}, giftRules: {}, t: {} }; }
      cfg.byN = {}; Object.keys(cfg.packs || {}).forEach(function (k) { var p = cfg.packs[k]; if (p && p.n) cfg.byN[p.n] = { id: parseInt(k, 10), plan: p.plan || null }; });
      cfg.maxN = Math.max.apply(null, Object.keys(cfg.byN).map(Number).concat([1]));
      cfg.maxBags = cfg.maxBags || 99;
      body = el.querySelector('[data-ntrl-cart-lines]');
      el.querySelectorAll('[data-ntrl-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
      el.addEventListener('click', onAction);
      fitPreviewBar();
      window.addEventListener('resize', fitPreviewBar);
      setInterval(function () { if (el.classList.contains('is-open')) fitPreviewBar(); }, 1000);
      return true;
    }
    // la barra de vista previa de Shopify tapa el pie del carrito: lo compensamos
    function fitPreviewBar() {
      var h = 0;
      ['PBarNextFrameWrapper', 'preview-bar-iframe'].forEach(function (id) {
        var f = document.getElementById(id); if (!f) return;
        var r = f.getBoundingClientRect(), cs = getComputedStyle(f);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.bottom >= window.innerHeight - 2) h = Math.max(h, Math.round(window.innerHeight - r.top));
      });
      el.style.setProperty('--ntrl-cart-bottom', h + 'px');
    }
    function lock(on) { document.documentElement.classList.toggle('ntrl-cart-lock', on); }
    function open() {
      if (!setup()) { window.location.href = ROOT + 'cart'; return; }
      fitPreviewBar();
      el.hidden = false; lock(true);
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    }
    function close() { if (!el) return; el.classList.remove('is-open'); lock(false); setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 350); }
    function req(url, data) {
      return fetch(ROOT + url, data ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) } : { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); return j; }); });
    }
    function getCart() { return req('cart.js').then(function (c) { last = c; return c; }); }

    function bagsOf(cart, mode) { return cart.items.reduce(function (a, i) { var p = packOf(i); return a + (!isGift(i) && p && modeOf(i) === mode ? p.n * i.quantity : 0); }, 0); }
    function compose(B) { // → { n: qty }
      var out = {}; if (B <= 0) return out;
      if (B <= cfg.maxN) { out[B] = 1; return out; }
      out[cfg.maxN] = 1; out[1] = (out[1] || 0) + (B - cfg.maxN); return out;
    }
    /* target = { sub: bolsas, once: bolsas } (si falta un modo, se deja como está) */
    function apply(cart, target) {
      var updates = {}, adds = [], finalSubVariants = [];
      ['sub', 'once'].forEach(function (mode) {
        var lines = cart.items.filter(function (i) { return !isGift(i) && packOf(i) && modeOf(i) === mode; });
        if (target[mode] === undefined) { lines.forEach(function (i) { if (mode === 'sub') finalSubVariants.push(i.variant_id); }); return; }
        var B = Math.max(0, Math.min(cfg.maxBags, target[mode]));
        var want = {}; var comp = compose(B);
        Object.keys(comp).forEach(function (n) { want[cfg.byN[n].id] = comp[n]; });
        lines.forEach(function (i) {
          var w = want[i.variant_id];
          if (w) { if (i.quantity !== w) updates[i.key] = w; delete want[i.variant_id]; }
          else updates[i.key] = 0;
        });
        Object.keys(want).forEach(function (vid) {
          var n = cfg.packs[vid].n, it = { id: parseInt(vid, 10), quantity: want[vid] };
          if (mode === 'sub') it.selling_plan = cfg.byN[n].plan;
          adds.push(it);
        });
        if (mode === 'sub') Object.keys(comp).forEach(function (n) { finalSubVariants.push(cfg.byN[n].id); });
      });
      giftDefs().forEach(function (g) {
        var need = 0; finalSubVariants.forEach(function (v) { need = Math.max(need, g[1][String(v)] || 0); });
        var gl = cart.items.filter(function (i) { return i.variant_id === g[0]; });
        gl.forEach(function (x, k) { var q = k === 0 ? need : 0; if (x.quantity !== q) updates[x.key] = q; });
        if (!gl.length && need > 0) adds.push({ id: g[0], quantity: need, properties: { _ntrl_regalo: 'pack' } });
      });
      var p = Promise.resolve();
      if (Object.keys(updates).length) p = p.then(function () { return req('cart/update.js', { updates: updates }); });
      if (adds.length) p = p.then(function () { return req('cart/add.js', { items: adds }); });
      return p.then(getCart);
    }
    function onAction(e) {
      var t = e.target.closest('[data-act]'); if (!t || busy || !last) return;
      e.preventDefault();
      var act = t.getAttribute('data-act'), mode = t.getAttribute('data-mode'), key = t.getAttribute('data-key');
      var tg = {};
      if (mode) {
        var B = bagsOf(last, mode);
        if (act === 'plus') tg[mode] = Math.min(cfg.maxBags, B + 1);
        else if (act === 'minus') tg[mode] = B - 1;
        else if (act === 'remove') tg[mode] = 0;
        else if (act === 'upsell') tg[mode] = Math.max(2, B);
        else if (act === 'tosub') { tg.once = 0; tg.sub = bagsOf(last, 'sub') + B; }
        if (tg[mode] === B && act !== 'tosub') return;
        return run(function () { return apply(last, tg); });
      }
      // otros productos (fuera de los packs): cantidad normal
      var line = last.items.filter(function (i) { return i.key === key; })[0]; if (!line) return;
      var q = act === 'remove' ? 0 : line.quantity + (act === 'plus' ? 1 : -1);
      run(function () { return req('cart/change.js', { id: key, quantity: Math.max(0, Math.min(99, q)) }).then(getCart); });
    }
    function run(fn) {
      busy = true; if (el) el.classList.add('is-busy');
      return Promise.resolve().then(fn).then(render).catch(function (e) { window.alert(e.message); return getCart().then(render); })
        .finally(function () { busy = false; if (el) el.classList.remove('is-busy'); });
    }

    /* Desde la ficha: el bundle de ese modo pasa a ser el pack elegido */
    function setPack(variantId, planId) {
      setup();
      var p = cfg.packs[String(parseInt(variantId, 10))];
      return getCart().then(function (cart) {
        if (!p) return req('cart/add.js', { items: [planId ? { id: +variantId, quantity: 1, selling_plan: +planId } : { id: +variantId, quantity: 1 }] }).then(getCart);
        var tg = {}; tg[planId ? 'sub' : 'once'] = p.n;
        return apply(cart, tg);
      }).then(function (c) { render(c); open(); return c; });
    }

    function render(cart) {
      if (!setup() || !cart) return;
      last = cart;
      var T = cfg.t || {}, html = '', cmpTotal = 0, hasSub = false, tags = {};
      var bundles = { sub: null, once: null }, others = [], gifts = [], giftBy = {};
      (cart.items || []).forEach(function (i) {
        var p = packOf(i), cmp;
        if (isGift(i)) {
          cmp = i.original_line_price;
          var g = giftBy[i.variant_id];
          if (!g) { g = giftBy[i.variant_id] = { id: i.variant_id, qty: 0, final: 0, cmp: 0, image: i.image, title: i.product_title }; gifts.push(g); }
          g.qty += i.quantity; g.final += i.final_line_price; g.cmp += cmp;
        } else if (p) {
          var m = modeOf(i); if (m === 'sub') hasSub = true;
          cmp = Math.max(p.compare * i.quantity, i.final_line_price);
          var b = bundles[m] || (bundles[m] = { mode: m, bags: 0, final: 0, cmp: 0, title: i.product_title, plan: planOf(i) });
          b.bags += p.n * i.quantity; b.final += i.final_line_price; b.cmp += cmp;
        } else { cmp = i.original_line_price; others.push(i); }
        cmpTotal += cmp;
        (i.discounts || []).forEach(function (d) { tags[d.title] = 1; });
      });
      function priceBlock(cmp, fin, free) {
        var save = cmp - fin;
        return '<div class="ntrl-cl__price">' + (save > 0 ? '<s>' + money(cmp) + '</s>' : '') +
          '<b' + (free ? ' class="is-free"' : '') + '>' + (free ? esc(T.free || 'Gratis') : money(fin)) + '</b>' +
          (save > 0 && !free ? '<span class="ntrl-cl__save">' + esc((T.save || 'Ahorras [amount]').replace('[amount]', money(save, true))) + '</span>' : '') + '</div>';
      }
      gifts.sort(function (a, b) { return (a.id === cfg.gift ? 0 : 1) - (b.id === cfg.gift ? 0 : 1); });
      function giftLines() { return gifts.map(giftLine).join(''); }
      function giftLine(gifts) {
        var img = gifts.image ? gifts.image + (gifts.image.indexOf('?') > -1 ? '&' : '?') + 'width=140' : '';
        var name = String(gifts.title || '').split(' · ')[0];
        return '<div class="ntrl-cl ntrl-cl--gift">' +
          '<span class="ntrl-cl__arrow" aria-hidden="true">' + ico('sub', 18) + '</span>' +
          '<span class="ntrl-cl__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
          '<div class="ntrl-cl__main"><div class="ntrl-cl__name">' + (gifts.qty > 1 ? gifts.qty + '× ' : '') + esc(name) + '</div>' +
          '<span class="ntrl-cl__gtag">' + ico('gift', 14) + esc(T.gift || 'Regalo') + '</span></div>' +
          priceBlock(gifts.cmp, gifts.final, gifts.final === 0) + '</div>';
      }
      function bundleLine(b) {
        var sub = b.mode === 'sub', img = cfg.packImg ? cfg.packImg + (cfg.packImg.indexOf('?') > -1 ? '&' : '?') + 'width=220' : '';
        var bagsTxt = b.bags === 1 ? (T.bag || '1 bolsa') : (T.bags || '[n] bolsas').replace('[n]', b.bags);
        var meta = sub
          ? '<span class="ntrl-cl__plan">' + ico('repeat', 15) + esc(T.sub || '') + '</span>'
          : '<button type="button" class="ntrl-cl__tosub" data-act="tosub" data-mode="once">' + ico('repeat', 15) + '<span>' + esc(T.once || '') + '</span></button>';
        return '<div class="ntrl-cl ntrl-cl--pack">' +
          '<span class="ntrl-cl__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="96">' : '') + (b.bags > 1 ? '<span class="ntrl-cl__n">×' + b.bags + '</span>' : '') + '</span>' +
          '<div class="ntrl-cl__main">' +
            '<div class="ntrl-cl__head"><div class="ntrl-cl__name">' + esc(b.title) + '</div>' +
              '<button type="button" class="ntrl-cl__del" data-act="remove" data-mode="' + b.mode + '" aria-label="Eliminar">' + ico('trash', 18) + '</button></div>' +
            '<div class="ntrl-cl__meta"><span class="ntrl-cl__bags">' + esc(bagsTxt) + '</span>' + meta + '</div>' +
            '<div class="ntrl-cl__row">' +
              '<div class="ntrl-cl__qty"><button type="button" data-act="minus" data-mode="' + b.mode + '" aria-label="Quitar una bolsa">' + ico('minus', 16) + '</button><span>' + b.bags + '</span><button type="button" data-act="plus" data-mode="' + b.mode + '" aria-label="Añadir una bolsa"' + (b.bags >= cfg.maxBags ? ' disabled' : '') + '>' + ico('plus', 16) + '</button></div>' +
              priceBlock(b.cmp, b.final, false) +
            '</div>' +
            (sub && b.bags === 1 && cfg.byN[2] && T.upsell ? '<button type="button" class="ntrl-cl__upsell" data-act="upsell" data-mode="sub">' + ico('up', 15) + '<span>' + esc(T.upsell) + '</span></button>' : '') +
          '</div></div>';
      }
      function otherLine(i) {
        var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=220' : '';
        return '<div class="ntrl-cl ntrl-cl--pack"><span class="ntrl-cl__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span><div class="ntrl-cl__main">' +
          '<div class="ntrl-cl__head"><div class="ntrl-cl__name">' + esc(i.product_title) + '</div><button type="button" class="ntrl-cl__del" data-act="remove" data-key="' + esc(i.key) + '" aria-label="Eliminar">' + ico('trash', 18) + '</button></div>' +
          (i.variant_title ? '<div class="ntrl-cl__meta"><span class="ntrl-cl__bags">' + esc(i.variant_title) + '</span></div>' : '') +
          '<div class="ntrl-cl__row"><div class="ntrl-cl__qty"><button type="button" data-act="minus" data-key="' + esc(i.key) + '">' + ico('minus', 16) + '</button><span>' + i.quantity + '</span><button type="button" data-act="plus" data-key="' + esc(i.key) + '">' + ico('plus', 16) + '</button></div>' +
          priceBlock(i.original_line_price, i.final_line_price, false) + '</div></div></div>';
      }
      if (bundles.sub) html += bundleLine(bundles.sub) + giftLines();
      if (bundles.once) html += bundleLine(bundles.once);
      if (!bundles.sub && gifts.length) html += giftLines();
      others.forEach(function (i) { html += otherLine(i); });
      body.innerHTML = html;

      var empty = !(cart.items || []).length;
      el.querySelector('[data-ntrl-cart-empty]').hidden = !empty;
      el.querySelector('[data-ntrl-cart-extras]').hidden = empty;
      el.querySelector('[data-ntrl-cart-foot]').hidden = empty;
      var ship = el.querySelector('[data-ntrl-cart-ship]');
      if (ship) { ship.hidden = empty; ship.classList.toggle('is-hint', !hasSub); ship.querySelector('[data-ntrl-cart-ship-text]').textContent = hasSub ? (T.shipSub || '') : (T.shipOnce || ''); }
      var disc = Math.max(0, cmpTotal - cart.total_price);
      var tagList = [];
      var offerSave = cmpTotal - (cart.items || []).reduce(function (a, i) { return a + i.original_line_price; }, 0);
      if (offerSave > 0 && T.offer) tagList.push(T.offer);
      Object.keys(tags).forEach(function (t) { tagList.push(t); });
      el.querySelector('[data-ntrl-cart-disc]').hidden = disc <= 0;
      el.querySelector('[data-ntrl-cart-tags]').innerHTML = tagList.map(function (t) { return '<span>' + ico('tag', 13) + '<span class="ntrl-cart__tagtxt">' + esc(t) + '</span></span>'; }).join('');
      el.querySelector('[data-ntrl-cart-disc-amt]').textContent = '-' + money(disc);
      el.querySelector('[data-ntrl-cart-total]').textContent = money(cart.total_price);
      updateCount(cart);
    }
    function updateCount(cart) {
      var n = 0; (cart.items || []).forEach(function (i) { if (!isGift(i)) { var p = packOf(i); n += p ? p.n * i.quantity : i.quantity; } });
      document.querySelectorAll('[data-ntrl-cart-count]').forEach(function (c) {
        var was = c.textContent; c.textContent = n; c.hidden = n < 1;
        if (String(n) !== was && !reduce) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      });
    }
    function refresh(openIt) {
      setup();
      if (openIt) { if (last) render(last); open(); }
      return getCart().then(function (c) {
        // si el carrito quedó descuadrado (regalos de más/de menos) un solo apply lo arregla
        var off = giftDefs().some(function (g) {
          var need = 0; c.items.forEach(function (i) { if (!isGift(i) && planOf(i)) need = Math.max(need, g[1][String(i.variant_id)] || 0); });
          var have = c.items.filter(function (i) { return i.variant_id === g[0]; }).reduce(function (a, i) { return a + i.quantity; }, 0);
          return have !== need;
        });
        return off ? apply(c, {}) : c;
      }).then(function (c) { render(c); return c; });
    }
    return { refresh: refresh, open: open, close: close, setup: setup, updateCount: updateCount, setPack: setPack };
  })();
  window.ntrlCart = Cart;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ntrl-cart-open]');
    if (!t || !document.querySelector('[data-ntrl-cart]')) return;
    e.preventDefault(); e.stopPropagation(); Cart.refresh(true);
  }, true);
  // precarga el carrito para que se abra al instante
  if (document.querySelector('[data-ntrl-cart]')) { var pre = function () { Cart.refresh(false).catch(function () {}); }; if ('requestIdleCallback' in window) requestIdleCallback(pre, { timeout: 2500 }); else setTimeout(pre, 1200); }

  /* ---------- Añadir al carrito ---------- */
  function addLine(variantId, planId, btn, err) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    if (err) err.hidden = true;
    var p;
    if (document.querySelector('[data-ntrl-cart]')) p = Cart.setPack(variantId, planId);
    else p = fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [planId ? { id: +variantId, quantity: 1, selling_plan: +planId } : { id: +variantId, quantity: 1 }] }) })
      .then(function () { window.location.href = ROOT + 'cart'; });
    return p.catch(function (e2) { if (err) { err.textContent = e2.message; err.hidden = false; } })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }
  function initForm(form) {
    if (!once(form, 'f')) return;
    var btn = form.querySelector('[data-ntrl-atc]');
    var err = form.querySelector('.ntrl-atc-error');
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return; // otra app ya gestiona el envío
      e.preventDefault();
      var fd = new FormData(form);
      addLine(fd.get('id'), fd.get('selling_plan') || null, btn, err);
    });
  }
  function initOnetime(link) {
    if (!once(link, 'o')) return;
    link.addEventListener('click', function () {
      var box = link.closest('.ntrl-buy');
      addLine(link.dataset.variant, null, null, box && box.querySelector('.ntrl-atc-error'));
    });
  }

  /* ---------- Selector de packs propio: variante, precios y regalos ---------- */
  function fmtMoney(n) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(n); }
    catch (e) { return '$' + (whole ? Math.round(n) : n.toFixed(2)); }
  }
  function initPacks(box) {
    if (!once(box, 'p')) return;
    var packs = box.querySelector('[data-ntrl-packs]');
    if (!packs) return;
    var radios = Array.prototype.slice.call(packs.querySelectorAll('.ntrl-pack__input'));
    var form = box.querySelector('form.ntrl-form');
    var idInput = form && form.querySelector('input[name="id"]');
    var planInput = form && form.querySelector('[data-ntrl-plan]');
    var onetime = box.querySelector('[data-ntrl-onetime]');
    var row = box.querySelector('[data-ntrl-subrow]');
    var badge = box.querySelector('[data-ntrl-atc-badge]');
    var tiles = Array.prototype.slice.call(packs.querySelectorAll('.ntrl-perk'));
    var count = packs.querySelector('[data-ntrl-perks-count]');
    function set(el, txt) { if (!el) return; if (!txt) { el.hidden = true; return; } el.hidden = false; if (el.textContent !== txt) el.textContent = txt; }
    function pulse(el) { if (!el || reduce) return; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    function current() { for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i]; return radios[0]; }
    function apply(first) {
      var r = current(); if (!r) return;
      radios.forEach(function (x) { x.closest('.ntrl-pack').classList.toggle('is-selected', x === r); });
      if (idInput) idInput.value = r.value;
      if (planInput) planInput.value = r.dataset.plan || '';
      if (onetime) {
        onetime.dataset.variant = r.value;
        if (onetime.dataset.tpl) onetime.textContent = onetime.dataset.tpl.replace('[n]', r.dataset.title || '').replace('[price]', r.dataset.onetime || '');
      }
      var pn = parseInt(r.dataset.price, 10) / 100, cn = parseInt(r.dataset.compare, 10) / 100;
      var hasC = cn > pn + 0.001;
      var p = fmtMoney(pn), c = hasC ? fmtMoney(cn) : '';
      [row, badge].forEach(function (w) {
        if (!w) return;
        set(w.querySelector('[data-ntrl-p]'), p);
        set(w.querySelector('[data-ntrl-c]'), c);
        if (!first) pulse(w.querySelector('[data-ntrl-p]'));
      });
      if (row) set(row.querySelector('[data-ntrl-t]'), hasC && row.dataset.tag ? row.dataset.tag.replace('[amount]', fmtMoney(Math.floor(cn - pn + 0.001))) : '');
      var n = parseInt(r.dataset.index, 10) || 1, open = 0;
      tiles.forEach(function (t) {
        var on = n >= parseInt(t.dataset.unlock, 10);
        if (on) open++;
        if (on && !t.classList.contains('is-open') && !first && !reduce) { t.classList.remove('is-pop'); void t.offsetWidth; t.classList.add('is-pop'); }
        t.classList.toggle('is-open', on);
      });
      if (count && tiles.length) { count.textContent = open + '/' + tiles.length; packs.classList.toggle('is-all', open === tiles.length); }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { apply(false); }); });
    // Si el navegador recuerda otra opción al volver atrás
    window.addEventListener('pageshow', function () { apply(true); });
    apply(true);
  }
  /* ---------- Animaciones al hacer scroll ---------- */
  var REVEAL = [
    '.ntrl-section .ntrl-eyebrow', '.ntrl-section .ntrl-title', '.ntrl-section .ntrl-sub', '.ntrl-pill',
    '.ntrl-compound', '.ntrl-rcard', '.ntrl-feat', '.ntrl-orbit', '.ntrl-benefit', '.ntrl-week', '.ntrl-reason',
    '.ntrl-stat', '.ntrl-stats__copy > *', '.ntrl-point', '.ntrl-vs', '.ntrl-guar__seal', '.ntrl-guar__media', '.ntrl-ritem',
    '.ntrl-score', '.ntrl-dist', '.ntrl-ugcgrid .ntrl-ugc-card', '.ntrl-offerbox', '.ntrl-stack', '.ntrl-journey__media',
    '.ntrl-seal', '.ntrl-chip', '.ntrl-section .ntrl-btn', '.ntrl-reviews__side .ntrl-btn'
  ].join(',');
  var io;
  function onSeen(el) {
    el.classList.add('is-in');
    if (el.classList.contains('ntrl-rv')) setTimeout(function () { el.classList.remove('ntrl-rv', 'is-in'); el.style.removeProperty('--ntrl-d'); }, 1400);
    // contadores
    el.querySelectorAll && [el].concat(Array.prototype.slice.call(el.querySelectorAll('[data-ntrl-count]'))).forEach(function (n) { if (n.hasAttribute && n.hasAttribute('data-ntrl-count')) countUp(n); });
    // barras
    [el].concat(Array.prototype.slice.call(el.querySelectorAll('[data-ntrl-bar]'))).forEach(function (b) { if (b.hasAttribute && b.hasAttribute('data-ntrl-bar')) b.classList.add('is-in'); });
  }
  function countUp(n) {
    if (!once(n, 'c')) return;
    var txt = n.textContent, m = txt.match(/(\d+(?:[.,]\d+)?)/);
    if (!m || txt.indexOf('[') > -1 || reduce) return;
    var raw = m[1], dec = raw.indexOf(',') > -1 ? ',' : (raw.indexOf('.') > -1 && raw.split('.')[1].length !== 3 ? '.' : null);
    var num = parseFloat(dec ? raw.replace(dec, '.') : raw.replace(/[.,]/g, ''));
    var places = dec ? raw.split(dec)[1].length : 0;
    var t0 = null, dur = 1200;
    function fmt(v) { var s = v.toFixed(places); if (dec === ',') s = s.replace('.', ','); if (!dec && raw.length > 3 && /[.,]/.test(raw)) s = Math.round(v).toLocaleString('es-ES'); return txt.replace(raw, s); }
    function frame(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - p, 3); n.textContent = fmt(num * e); if (p < 1) requestAnimationFrame(frame); else n.textContent = txt; }
    requestAnimationFrame(frame);
  }
  function initReveal(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { onSeen(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    scope.querySelectorAll('.ntrl').forEach(function (sec) {
      var items = sec.querySelectorAll(REVEAL);
      items.forEach(function (el) {
        if (!once(el, 'r')) return;
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--ntrl-d', Math.min(sib, 6) * 70 + 'ms');
        el.classList.add('ntrl-rv');
        if (design) { onSeen(el); return; }
        io.observe(el);
      });
      sec.querySelectorAll('[data-ntrl-bar]').forEach(function (b) { if (once(b, 'b')) { b.classList.add('ntrl-bar-rv'); io.observe(b); } });
      sec.querySelectorAll('[data-ntrl-count]').forEach(function (n) { io.observe(n); });
    });
  }

  /* ---------- Línea de progreso de la timeline ---------- */
  function initTimeline(tl) {
    if (!once(tl, 'l') || reduce) return;
    function upd() {
      var r = tl.getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.max(0, Math.min(1, (vh * 0.7 - r.top) / r.height));
      tl.style.setProperty('--ntrl-p', p.toFixed(3));
      tl.querySelectorAll('.ntrl-week').forEach(function (w) { var wr = w.getBoundingClientRect(); w.classList.toggle('is-active', wr.top < vh * 0.7); });
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  /* ---------- Reseñas: «Ver más» ---------- */
  function initMore(btn) {
    if (!once(btn, 'm')) return;
    var wrap = btn.closest('[data-ntrl-more-wrap]');
    btn.addEventListener('click', function () {
      var step = parseInt(btn.dataset.step || '4', 10);
      var hidden = wrap.querySelectorAll('.ntrl-ritem.is-hidden');
      Array.prototype.slice.call(hidden, 0, step).forEach(function (el, i) {
        el.classList.remove('is-hidden');
        if (!reduce) { el.classList.add('ntrl-rv'); el.style.setProperty('--ntrl-d', i * 70 + 'ms'); requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); }); }
      });
      if (wrap.querySelectorAll('.ntrl-ritem.is-hidden').length === 0) btn.remove();
    });
  }

  /* ---------- Header: menú móvil, sombra al hacer scroll, contador del carrito ---------- */
  function initHeader(h) {
    if (!once(h, 'h')) return;
    var burger = h.querySelector('[data-ntrl-burger]'), drawer = h.querySelector('[data-ntrl-drawer]');
    function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; var c = drawer.querySelector('[data-ntrl-close]:not(.ntrl-drawer__overlay)'); if (c) c.focus(); }
    function close() { drawer.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 320); burger.focus(); }
    if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
    if (burger && drawer) {
      burger.addEventListener('click', open);
      drawer.querySelectorAll('[data-ntrl-close]').forEach(function (b) { b.addEventListener('click', close); });
      drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    var hdr = h.querySelector('.ntrl-header') || h;
    function sc() { hdr.classList.toggle('is-scrolled', window.scrollY > 8); }
    window.addEventListener('scroll', sc, { passive: true }); sc();
  }
  function refreshCartCount() {
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { Cart.setup(); Cart.updateCount(c); }).catch(function () {});
  }
  document.addEventListener('ntrl:cart-changed', refreshCartCount);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });

  /* ---------- Sección Confianza ---------- */
  function initTrust(t) {
    if (!once(t, 't')) return;
    t.querySelectorAll('.ntrl-pillar').forEach(function (p) {
      p.addEventListener('pointermove', function (e) { var r = p.getBoundingClientRect(); p.style.setProperty('--mx', (e.clientX - r.left) + 'px'); p.style.setProperty('--my', (e.clientY - r.top) + 'px'); });
    });
    if (reduce || design || !('IntersectionObserver' in window)) { t.classList.add('is-in'); return; }
    var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { t.classList.add('is-in'); o.disconnect(); } }); }, { threshold: 0.15 });
    o.observe(t);
  }

  /* ---------- Ajustar texto a una línea (notas bajo el botón) ---------- */
  function fitLine(el) {
    el.style.fontSize = ''; el.classList.remove('no-ico');
    var fs = parseFloat(getComputedStyle(el).fontSize), min = 13;
    while (el.scrollWidth > el.clientWidth + 1 && fs > min) { fs -= 0.5; el.style.fontSize = fs + 'px'; }
    if (el.scrollWidth > el.clientWidth + 1) el.classList.add('no-ico');
  }
  function initFit(el) {
    if (!once(el, 'f')) return;
    fitLine(el);
    var lw = 0; if ('ResizeObserver' in window) new ResizeObserver(function (en) { var w = Math.round(en[0].contentRect.width); if (w !== lw) { lw = w; fitLine(el); } }).observe(el.parentElement || el);
  }

  /* ---------- Barra de oferta: una línea; si no cabe, se desliza ---------- */
  function initAnn(vp) {
    if (!once(vp, 'a')) return;
    var track = vp.querySelector('.ntrl-announce__track'), item = track && track.querySelector('.ntrl-announce__item');
    if (!item) return;
    var lw = -1;
    function check() {
      var w = vp.parentElement.clientWidth; if (w === lw) return; lw = w;
      track.querySelectorAll('[data-dup]').forEach(function (d) { d.remove(); });
      vp.classList.remove('is-marquee');
      if (item.scrollWidth > vp.clientWidth + 1) {
        var c = item.cloneNode(true); c.setAttribute('data-dup', ''); c.setAttribute('aria-hidden', 'true'); track.appendChild(c);
        vp.style.setProperty('--ann-dur', Math.max(12, Math.round(item.scrollWidth / 45)) + 's');
        vp.classList.add('is-marquee');
      }
    }
    check();
    window.addEventListener('resize', check);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { lw = -1; check(); });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ntrl-timer]').forEach(initTimer);
    scope.querySelectorAll('[data-ntrl-delivery]').forEach(initDelivery);
    scope.querySelectorAll('.ntrl-gallery').forEach(initGallery);
    scope.querySelectorAll('[data-ntrl-scroller]').forEach(initScroller);
    scope.querySelectorAll('.ntrl-ugc-card').forEach(initVideoCard);
    scope.querySelectorAll('.ntrl details').forEach(initDetails);
    scope.querySelectorAll('form.ntrl-form').forEach(initForm);
    scope.querySelectorAll('[data-ntrl-onetime]').forEach(initOnetime);
    scope.querySelectorAll('.ntrl-buy').forEach(initPacks);
    scope.querySelectorAll('[data-ntrl-more]').forEach(initMore);
    if (scope.matches && scope.matches('[data-ntrl-header]')) initHeader(scope); scope.querySelectorAll('[data-ntrl-header]').forEach(function (h) { initHeader(h.parentElement || h); });
    scope.querySelectorAll('.ntrl-timeline').forEach(initTimeline);
    scope.querySelectorAll('[data-ntrl-trust]').forEach(initTrust);
    scope.querySelectorAll('[data-ntrl-fit]').forEach(initFit);
    scope.querySelectorAll('[data-ntrl-ann]').forEach(initAnn);
    initReveal(scope);
    document.documentElement.classList.add('ntrl-js');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
